var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('msg-dialog'),_c('message-model'),_c('loading'),_c('div',{staticClass:"company-footer-info"},[_vm._v(" 粤ICP备20054168号 © 宋氏科技 版权所有 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }